import axios from 'axios';
import api from '../../../utilidades/interceptor';
const urlApi = process.env.REACT_APP_API_KEY
const API_BASE_URL = `${urlApi}/api/files`; // Asegúrate de que esta URL sea correcta

// Helper para configurar headers con currentPath
const getConfig = (currentPath) => ({
  headers: {
    'x-current-path': encodeURIComponent(currentPath)
  }
});

export const getFiles = async (currentPath = '') => {
  try {
    // CAMBIO CLAVE: Se envía currentPath en el HEADER para GET
    const response = await api.get(API_BASE_URL, getConfig(currentPath));
    return response.data;
  } catch (error) {
    console.error('API Error (getFiles):', error);
    throw error;
  }
};

export const createFile = async (file, currentPath = '',id_user) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('id_user', id_user);
  try {
    const response = await api.post(`${API_BASE_URL}/file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-current-path': encodeURIComponent(currentPath) // Envía currentPath en header para POST de archivo
      }
    });
    return response.data;
  } catch (error) {
    console.error('API Error (createFile):', error);
    throw error;
  }
};

export const createFolder = async (folderName, currentPath = '',id_user) => {
  try {
    const response = await api.post(`${API_BASE_URL}/folder`, { folderName, currentPath,id_user }); // currentPath en el body para carpetas
    return response.data;
  } catch (error) {
    console.error('API Error (createFolder):', error);
    throw error;
  }
};

export const renameItem = async (oldName, newName, currentPath = '',id_user) => {
  try {
    const response = await api.put(`${API_BASE_URL}/rename`, { oldName, newName, currentPath ,id_user}); // currentPath en el body para renombrar
    return response.data;
  } catch (error) {
    console.error('API Error (renameItem):', error);
    throw error;
  }
};

export const deleteItem = async (name, currentPath = '',id_user) => {
  try {
    // CAMBIO CLAVE: Se envía currentPath en el HEADER para DELETE
    const response = await api.delete(`${API_BASE_URL}/${encodeURIComponent(name)}?id_user=${id_user}`, getConfig(currentPath));
    return response.data;
  } catch (error) {
    console.error('API Error (deleteItem):', error);
    throw error;
  }
};